import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@material-ui/core';
import React, { useState, useEffect, useRef } from 'react';
import QRCode from 'qrcode.react';
import GetAppIcon from '@material-ui/icons/GetApp';

export default function ConfirmationDialog2 (props) {

    const qrCodeRef = useRef(null);
    const handleClose = event => { props.setOpen (false)  };
    const handleCancel = event => { props.setOpen (false) };
    const handleAgree = event => { props.confirmingAction(); props.setOpen (false)  };

    const handleDownload = () => {
        if (qrCodeRef.current) {
            const canvas = qrCodeRef.current.querySelector('canvas');
            if (canvas) {
                const url = canvas.toDataURL('image/png');
                const link = document.createElement('a');
                link.download = `qrcode-${props.qrCodeValue || props.dialogMessage || 'qr'}.png`;
                link.href = url;
                link.click();
            }
        }
    };

    return (
        
            <Dialog open = { props.open } onClose = { handleClose }  >
                <DialogTitle> { props.dialogTitle } </DialogTitle>
                <DialogContent> 
                    <DialogContentText> { props.dialogMessage } </DialogContentText>
                    { (props.qrCodeValue || props.dialogMessage) && (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '16px 0', position: 'relative' }}>
                            <div ref={qrCodeRef}>
                                <QRCode value = { props.qrCodeValue || props.dialogMessage } size = { 256 } />
                            </div>
                            <IconButton 
                                onClick={handleDownload}
                                style={{ 
                                    position: 'absolute', 
                                    top: 0, 
                                    right: 0,
                                    backgroundColor: '#138DE8',
                                    color: 'white'
                                }}
                                size="small"
                                aria-label="download qr code"
                            >
                                <GetAppIcon />
                            </IconButton>
                        </div>
                    )}
                    <DialogActions>  
                        <Button   style = {{ backgroundColor : '#138DE8', color : 'floralwhite' }}  onClick = { handleCancel }  > Cancel </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
        
    );
};